import React, { Component } from "react";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper";
import { TableComp } from "sz-react-utils";
import moment from "moment";
import lodash from "lodash";
import {
    Button,
    Card,
    Checkbox,
    DatePicker,
    Drawer,
    notification,
    Tooltip,
    Select,
    Row,
    Col,
} from "antd";

import Request from "../../../request";

import { connect } from "react-redux";
import styles from "./styles.less";

import { RightsWrapper } from "../../../components/_utils/utils";
import VisaListFollowUps from "../../../components/_utils/visaListFollowUp";
import { hideLoader, showLoader } from "../../../modules/actions";
import ListFollowUp from '../../../components/_utils/listUniversityFollowUp';
let universityObj = {};
const Option = Select.Option;
const { RangePicker } = DatePicker;
const dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : "DD.MM.YYYY"

class CollapseViewBox extends Component {
    state = {
        cp: true,
    };

    render() {
        const { cp } = this.state;

        return (
            <React.Fragment>
                <div
                    className={
                        cp
                            ? styles.followUpDetailsCollapse
                            : styles.followUpDetailsCollapseNot
                    }
                >
                    {this.props.children}
                </div>
                <button
                    style={{ color: "red", float: "right" }}
                    onClick={() => {
                        this.setState({
                            cp: !cp,
                        });
                    }}
                >
                    {cp ? <p>View More + </p> : <p>View Less - </p>}
                </button>
            </React.Fragment>
        );
    }
}

class UniversityAgreementFollowUps extends Component {
    state = {
        count: 0,
        showFollowUp: false,
        allCounsellor: [],
        userCheckBox: [],
        countryFilter: [],
        filterByCurrentUser: true,
        showDate: false,
        disabledRangePicker: true,
        showResults: true,
        // time: {
        //   key: "time",
        //   from: moment()
        //     .startOf("day")
        //     .subtract(1, "year")
        //     .format("YYYY-MM-DD HH:mm"),
        //   to: moment()
        //     .endOf("day")
        //     .format("YYYY-MM-DD HH:mm"),
        // },
        time: {},
        isAdmin: false,
        showSMS: false,
        showWhatsAppSms: false,
        showEmail: false,
        visiblePostponed: false,
        followUpDate: new Date(),
        isCounsellor: false,
        followUpType: "",
        followUpCounts: {},
        followUpTypeArr: [
            "Active",
            "Busy, Call Later",
            "Cold",
            "Didn't Pick up Call",
            "Not Interested",
            "Out Of town",
        ],
        ratingArr: [],
        countryArr: [],
        rating: null,
    };
    loadFollowTypeCounts = async () => {
        let response = await Request.loadUserFollowUpsCount();
        if (response) {
            this.setState({ followUpCounts: response });
        }
    };
    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            if (!params.sortField) {
                params.results = "50";
                params.count = "50";
                params.sortField = "id";
                params.sortOrder = "descend";
            }

            if (this.state && this.state.followUpType) {
                params.followUpType = this.state.followUpType;
            }

            if (this.state.countryId) {
                params.countryId = this.state.countryId;
            }
            let userCheckBox = {}
            let data = await Request.getUniversityAgreementFollowUps({
                ...params,
                followUpDate: this.state && this.state.time,
            })
            // let data = await Request.getBusinessProposalFollowUps({
            //     ...params,
            //     followUpDate: this.state && this.state.time,
            // })
            this.setState({ count: data.total });
            resolve(data);
        });
    };
    chooseRangerPicker = (date, dateString) => {
        this.setState(
            {
                time: {
                    key: "time",
                    from: date[0],
                    to: date[1],
                },
            },
            () => {
                //console.log(this.state.time, '@@@@@@@@@@@@@@@@@@@')
            }
        );

        if (date[0] === undefined) {
            setTimeout(() => {
                this.reload();
            }, 500);
        }
    };
    openFollowUps = (record) => {
        universityObj = {
            name: record.universityInstitutionName,
            _id: record._id
        }
        this.setState({ showFollowUp: true });
    };

    onRatingChoose = async (rating, id) => {
        let obj = {
            _id: id,
            counsellingDesk: {
                rating,
            },
        };
        let x = await Request.updateRating({ ...obj });
        if (x) {
            if (!x.error) {
                notification.success({
                    message: "Success",
                    description: x.msg,
                });
            } else {
                notification.error({
                    message: "Error Saving",
                    description: x.msg,
                });
            }
        }
        this.table.current.reload();
    };

    renderStatus = (val, id = "", isRating = false) => {
        if (val === "Super Hot") {
            return <div className={styles.SuperHot}>{val.toUpperCase()}</div>;
        }
        if (val === "Fit2Apply" || val === "Didn't Pick up Call") {
            return <div className={styles.Fit2Apply}>{val.toUpperCase()}</div>;
        }

        if (val === "Luke Warm" || val === "Neutral" || val === "Out Of town") {
            return <div className={styles.LukeWarm}>{val.toUpperCase()}</div>;
        }

        if (val === "Potential" || val === "Not Interested") {
            return <div className={styles.Potential}>{val.toUpperCase()}</div>;
        }

        if (val === "Dead" || val === "Busy, Call Later") {
            return <div className={styles.dead}>{val.toUpperCase()}</div>;
        }

        if (val === "Cold" || val === "Active") {
            return <div className={styles.Cold}>{val.toUpperCase()}</div>;
        }

        if (
            isRating === true &&
            (val === "" || val === null || val === undefined)
        ) {
            return (
                <Select
                    style={{ width: 90 }}
                    value={this.state.rating}
                    placeholder="Select Rating"
                    optionFilterProp="display"
                    onChange={(val) => {
                        this.onRatingChoose(val, id);
                    }}
                >
                    {this.state.ratingArr.slice(0, -1).map((rEl, i) => {
                        return (
                            <Option key={i} value={rEl}>
                                {rEl}
                            </Option>
                        );
                    })}
                </Select>
            );
        }
    };


    closeFollowUp = () => {
        this.setState({ showFollowUp: false });
        this.reload();
    };
    onOk = (value) => {
        this.setState({ showResults: true }, () => {
            this.reload();
        });
    };
    reload = () => {
        this.table.current.reload();
    };

    getAllRatings = async () => {
        let response = await Request.getRatingsDetails({
            results: 1000,
            count: 1000,
        });
        this.setState({ ratingArr: response.data });
    };

    constructor(props) {
        super(props);
        this.table = React.createRef();
        this.getAllRatings();
        this.loadFollowTypeCounts();
    }


    componentWillMount() {
        let searchParams = new URLSearchParams(this.props.search);
        let followUpType = searchParams.get("followUpType");
        this.setState({ followUpType: followUpType });
        let followUpShow = searchParams.get("followUpShow");
        if (followUpShow === "Today") {
            let sDate = moment()
                .startOf("day")
                .format("YYYY-MM-DD HH:mm");
            let eDate = moment()
                .endOf("day")
                .format("YYYY-MM-DD HH:mm");
            this.chooseRangerPicker([sDate, eDate]);

            setTimeout(() => {
                this.onOk();
            }, 1000);
        } else if (followUpShow === "OverDue") {
            let sDate = moment()
                .subtract(31, "days")
                .startOf("day")
                .format("YYYY-MM-DD HH:mm");
            let eDate = moment()
                .subtract(1, "days")
                .endOf("day")
                .format("YYYY-MM-DD HH:mm");
            this.chooseRangerPicker([sDate, eDate]);

            setTimeout(() => {
                this.onOk();
            }, 1000);
        }
        if (followUpType) {
            setTimeout(() => {
                this.onOk();
            }, 1000);
        }
    }


    async componentDidMount() {
        let isCounsellor = true,
            isAdmin = false;

        let localUser = JSON.parse(localStorage.getItem("user"));
        if (localUser) {
            // isCounsellor = localUser.isCounsellor;
            if (localUser.userType === "Admin") {
                isAdmin = true;
            }
        }

        this.setState({
            loading: false,
            isCounsellor,
            isAdmin,
        });
    }

    render() {
        const { dispatch } = this.props;
        const {
            allCounsellor,
            userCheckBox,
            followUpTypeArr,
            ratingArr,
            followUpCounts,
        } = this.state;


        const columns = [
            {
                title: 'Sr. No',
                key: 'serialNumber',
                render: (text, record, index) => (
                    <span>{index + 1}</span>
                )
            },
            {
                title: "Action",
                key: 'operation',
                render: (text, record) => (
                    <RightsWrapper myRight={"BusinessProposalsFollowUps.view"}>
                        <Tooltip title="FollowUp">
                            <Button
                                size={"small"}
                                shape="circle"
                                onClick={() => this.openFollowUps(record)}
                                icon="eye"
                            />
                        </Tooltip>
                    </RightsWrapper>
                )
            },
            {
                title: 'University Name',
                key: 'universityInstitutionName'
            },
            {
                title: 'Country Name',
                key: 'universityCountryName'
            },
            {
                title: 'State Name',
                key: 'universityStateName'
            },
            {
                title: 'City Name',
                key: 'universityCityName'
            },
            {
                title: "Last Follow Up Date",
                key: "followUp.followUpDate",
                width: 100,
                render: (trdd, record) => {
                    return <div>{record.followUp && record.followUp.createdByUser ? moment(record.followUp.createdByUser.time).format(dateFormat) : null}</div>;
                },
            },
            {
                title: "Next Follow Up Date",
                key: "followUp.followUpDate",
                width: 100,
                render: (trdd, record) => {
                    return <div>{record.followUp ? moment(record.followUp.followUpDate).format(dateFormat) : null}</div>;
                },
            },
            {
                title:'Details',
                key:'followUp.details'
            }
        ]

        // const columns = [
        //   {
        //     title: "Action",
        //     key: "operation",
        //     float: "right",
        //     fixed: "left",
        //     width: 100,
        //     render: (text, record) => (
        //       <React.Fragment>
        //         {/* <span className={styles.userSelectCheckbox}>
        //           <Checkbox
        //             checked={
        //               userCheckBox[record._id]
        //                 ? userCheckBox[record._id].isChecked
        //                 : false
        //             }
        //             onChange={(y) => {
        //               this.selectUser(y, record._id);
        //             }}
        //           />
        //         </span> */}

        //         <Tooltip title="View more followups">
        //           <Button
        //             className={styles.btn}
        //             shape="circle"
        //             size="small"
        //             onClick={() => this.openFollowUps(record)}
        //             icon="eye"
        //           />
        //         </Tooltip>
        //       </React.Fragment>
        //     ),
        //   },
        //   {
        //     title: "Vision Id",
        //     key: "id",
        //     dataIndex: "id",
        //     searchTextName: "id",
        //     width: 100,
        //   },
        //   {
        //     title: "Applicant Name",
        //     key: "applicantName",
        //     dataIndex: "applicantName",
        //     searchTextName: "applicantName",
        //     filterRegex: true,
        //     width: 140,
        //     render: (val, record) => {
        //       return (
        //         <div>
        //           {val}
        //           <div className={styles.parentGuardianName}>
        //             {record.parentGuardianName
        //               ? "Parent/Guardian Name: " + record.parentGuardianName
        //               : ""}
        //           </div>
        //         </div>
        //       );
        //     },
        //   },
        //   {
        //     title: "Mobile",
        //     key: "mobileNumber",
        //     dataIndex: "mobileNumber",
        //     searchTextName: "mobileNumber",
        //     filterRegex: true,
        //     width: 110,
        //     render: (val, record) => {
        //       return (
        //         <div>
        //           {" "}
        //           {val &&
        //           val.length === 10 &&
        //           rightAuth.checkRights("ShowClickToCall.view") ? (
        //             <Tooltip title="Start Call">
        //               <Button
        //                 className="ant-btn ant-btn-primary"
        //                 onClick={(e) => {
        //                   dispatch(showLoader());
        //                   Request.callInitiate({
        //                     mobile: val,
        //                   }).then(({ data, error, message }) => {
        //                     dispatch(hideLoader());
        //                     if (!error) {
        //                       notification.success({
        //                         message: message,
        //                       });
        //                     } else {
        //                       notification.error({
        //                         message: message,
        //                       });
        //                     }
        //                   });
        //                 }}
        //               >
        //                 Click To Call
        //               </Button>
        //             </Tooltip>
        //           ) : (
        //             val
        //           )}
        //         </div>
        //       );
        //     },
        //   },
        //   // {
        //   //   title: "Whatsapp",
        //   //   key: "watsupp",
        //   //   dataIndex: "watsupp",
        //   //   searchTextName: "watsupp",
        //   //   filterRegex: true,
        //   //   width: 120,
        //   //   render: (val, record) => {
        //   //     let studentMobile = record.watsupp ? record.watsupp : record.mobile;
        //   //     return (
        //   //       <div>
        //   //         {" "}
        //   //         {studentMobile && studentMobile.length === 10 ? (
        //   //           <Tooltip title="Send Whatsapp Message">
        //   //             <a
        //   //               target={"_blank"}
        //   //               className="ant-btn ant-btn-primary"
        //   //               href={`whatsapp://send?text=Hi&phone=91${studentMobile}`}
        //   //             >
        //   //               Click To Send
        //   //             </a>
        //   //           </Tooltip>
        //   //         ) : (
        //   //           studentMobile
        //   //         )}
        //   //       </div>
        //   //     );
        //   //   },
        //   // },
        //   // {
        //   //   title: "Email",
        //   //   key: "emailId",
        //   //   dataIndex: "emailId",
        //   //   searchTextName: "emailId",
        //   //   filterRegex: true,
        //   //   width: 130,
        //   // },
        //   {
        //     title: "Counsellor",
        //     key: "cName",
        //     width: 120,
        //     dataIndex: "cName",
        //     filters:
        //       allCounsellor &&
        //       allCounsellor.map((x) => ({ value: x._id, text: x.name })),
        //     render: (text, record) => {
        //       return (
        //         <div>{record.counsellorId ? record.counsellorId.name : ""}</div>
        //       );
        //     },
        //   },

        //   // {
        //   //   title: "Desk",
        //   //   key: "atLevel",
        //   //   dataIndex: "atLevel",
        //   //   width: 100,
        //   //   filters: [
        //   //     { text: `${setting.deskNameObj["Front Desk"]}`, value: "Front Desk" },
        //   //     { text: "Registration Desk", value: "Registration Desk" },
        //   //     { text: "Application Desk", value: "Application Desk" },
        //   //     { text: "Visa Desk", value: "Visa Desk" },
        //   //     { text: "Claim Desk", value: "Claim Desk" },
        //   //   ],
        //   //   render: (trdd, record) => {
        //   //     return <div>{setting.deskNameObj[trdd]}</div>;
        //   //   },
        //   // },

        //   // {
        //   //   title: "Last Follow Date",
        //   //   key: "entryDate",
        //   //   dataIndex: "entryDate",
        //   //   width: 100,
        //   //   searchDateName: "entryDate",
        //   //   render: (val, record) => {
        //   //     return (
        //   //       <div>
        //   //         {record.entryDate
        //   //           ? moment(record.entryDate).format("DD-MMM-YYYY")
        //   //           : ""}
        //   //       </div>
        //   //     );
        //   //   },
        //   // },

        //   {
        //     title: "Next Follow Up Date",
        //     key: "followUpDate",
        //     width: 100,
        //     render: (trdd, record) => {
        //       return <div>{record.followUpDate}</div>;
        //     },
        //   },
        //   {
        //     title: "Details",
        //     key: "detail",
        //     width: 150,
        //     dataIndex: "detail",
        //     searchTextName: "detail",
        //     render: (text, record) => {
        //       let u = record && record.followUp && record.followUp.details?record.followUp.details:null;
        //       if (u && u.length <= 100) {
        //         return <div>{u ? S(u).s : "N/A"}</div>;
        //       } else {
        //         return <CollapseViewBox>{u ? S(u).s : "N/A"}</CollapseViewBox>;
        //       }
        //     },
        //   },
        //     // {
        //     //   title: "Preference",
        //     //   key: "country",
        //     //   dataIndex:'country',
        //     //   width: 150,
        //     //   filters:this.state.countryFilter,
        //     //   render: (val, row) => {
        //     //     return row.country ? (
        //     //       <ul className={common.ul}>
        //     //         {row.country.map((val, inde) => {
        //     //           return <li key={inde}>{val ? val.country : ""}</li>;
        //     //         })}
        //     //       </ul>
        //     //     ) : null;
        //     //   },
        //     // },
        //   // {
        //   //   title: "Language",
        //   //   key: "language",
        //   //   width: 150,
        //   //   dataIndex: "language",
        //   //   render: (text, record) => {
        //   //     let u = record && record.profile;
        //   //     if (u.listening) {
        //   //       let ieltsDetails = [];
        //   //       if (u.listening) {
        //   //         ieltsDetails.push("L " + u.listening);
        //   //       }
        //   //       if (u.reading) {
        //   //         ieltsDetails.push("R " + u.reading);
        //   //       }
        //   //       if (u.speaking) {
        //   //         ieltsDetails.push("S " + u.speaking);
        //   //       }
        //   //       if (u.writing) {
        //   //         ieltsDetails.push("W " + u.writing);
        //   //       }
        //   //       if (u.overAllScore) {
        //   //         ieltsDetails.push("O " + u.overAllScore);
        //   //       }
        //   //       return <>{ieltsDetails.join(", ")}</>;
        //   //     } else {
        //   //       return "";
        //   //     }
        //   //   },
        //   // },
        //   // {
        //   //   title: "Qualification",
        //   //   key: "qualification",
        //   //   width: 250,
        //   //   dataIndex: "qualification",
        //   //   render: (text, record) => {
        //   //     if (record && record.profile && record.profile.newQualification) {
        //   //       let qualifications =
        //   //         record && record.profile && record.profile.newQualification;
        //   //       if (qualifications.length > 0) {
        //   //         var qualificationsHtml = [];
        //   //         qualifications.forEach((qualification) => {
        //   //           if (qualification) {
        //   //             let qualificationArray = [];
        //   //             if (qualification.qualification) {
        //   //               qualificationArray.push(qualification.qualification);
        //   //             }
        //   //             if (qualification.passingYear) {
        //   //               qualificationArray.push(qualification.passingYear);
        //   //             }
        //   //             if (qualification.percentage) {
        //   //               qualificationArray.push(qualification.percentage + "%");
        //   //             }
        //   //             if (
        //   //               qualification.stream &&
        //   //               Array.isArray(qualification.stream)
        //   //             ) {
        //   //               qualificationArray.push(qualification.stream.join(" | "));
        //   //             } else {
        //   //               qualificationArray.push(qualification.stream);
        //   //             }
        //   //             if (
        //   //               qualification.major &&
        //   //               Array.isArray(qualification.major)
        //   //             ) {
        //   //               qualificationArray.push(qualification.major.join(" | "));
        //   //             } else {
        //   //               qualificationArray.push(qualification.major);
        //   //             }
        //   //             if (qualification.backlogs) {
        //   //               qualificationArray.push(
        //   //                 qualification.backlogs + "Backlogs"
        //   //               );
        //   //             }
        //   //             if (qualification.degreeType) {
        //   //               qualificationArray.push(qualification.degreeType);
        //   //             }
        //   //             let qualificationHtml = (
        //   //               <div>
        //   //                 {qualificationArray.join(", ")}
        //   //                 <br />
        //   //                 <br />
        //   //               </div>
        //   //             );
        //   //             qualificationsHtml.push(qualificationHtml);
        //   //           }
        //   //         });
        //   //         return qualificationsHtml;
        //   //       } else {
        //   //         return "";
        //   //       }
        //   //     }
        //   //   },
        //   // },
        //   {
        //     title: "Branch",
        //     key: "studentBranchId",
        //     width: 100,
        //     render: (text, record) => {
        //       return (
        //         <div>
        //           {record && record.branchId ? record.branchId.branchName : ""}
        //         </div>
        //       );
        //     },
        //   },
        //   // {
        //   //   title: "Rating",
        //   //   key: "rating",
        //   //   width: 170,
        //   //   dataIndex: "rating",
        //   //   filters:
        //   //     ratingArr &&
        //   //     ratingArr.map((x) => ({ value: x._id, text: x.ratingName })),
        //   //   render: (val, record) => {
        //   //     let ratingObject =
        //   //       record.counsellingDesk && record.counsellingDesk.ratingObject
        //   //         ? record.counsellingDesk.ratingObject
        //   //         : null;
        //   //     let subRatingObject =
        //   //       record.counsellingDesk && record.counsellingDesk.subRatingObject
        //   //         ? record.counsellingDesk.subRatingObject
        //   //         : null;
        //   //     return (
        //   //       <div>
        //   //         {ratingObject ? (
        //   //           <div
        //   //             className="antd-pro-containers-desk-counselling-all-styles-rating"
        //   //             style={{
        //   //               background: ratingObject.ratingColor,
        //   //               borderColor: ratingObject.ratingColor,
        //   //             }}
        //   //           >
        //   //             {ratingObject.ratingName}{" "}
        //   //             {subRatingObject && subRatingObject.ratingName
        //   //               ? "/ " + subRatingObject.ratingName
        //   //               : ""}
        //   //           </div>
        //   //         ) : null}
        //   //       </div>
        //   //     );
        //   //   },
        //   // },
        //   {
        //     title: "FollowUp Type",
        //     key: "followUpType",
        //     width: 100,
        //     dataIndex: "followUpType",
        //     filters:
        //       followUpTypeArr &&
        //       followUpTypeArr.map((x) => ({ value: x, text: x })),
        //     render: (val, record) => {
        //       return this.renderStatus(val);
        //     },
        //   },
        //   {
        //     title: "Added By",
        //     key: "createdByUser.name",
        //     dataIndex: "createdByUser.name",
        //     searchTextName: "createdByUser.name",
        //     width: 100,
        //     filterRegex: true,
        //     render: (text, record) => {
        //       return (
        //         <div>
        //           <div className={common.user}>{record.createdByUser.name}</div>
        //           <small>{moment(record.createdByUser.time).format("DD-MM-YYYY HH:MM A")}</small>
        //         </div>
        //       );
        //     },
        //   },
        // ];
        return (
            <PageHeaderWrapper title={` FollowUps : ${this.state.count} `}>


                {
                    this.state.showFollowUp ?
                        <ListFollowUp universityObj={universityObj} onClose={this.closeFollowUp} />
                        : null
                }

                <Card style={{ marginBottom: "10px" }}>
                    <Row>
                        <Col span={24} style={{ marginBottom: "30px" }}>
                            <Button
                                type="info"
                                style={{ backgroundColor: "blue", color: "white" }}
                                className={styles.btn1}
                                onClick={() => {
                                    this.setState({ disabledRangePicker: true });
                                    this.setState({ showDate: false });
                                    this.onOk();
                                }}
                            >
                                Totals ({followUpCounts.totalFollowups})
                            </Button>
                            <Button
                                className={styles.btn1}
                                type="primary"
                                onClick={() => {
                                    let sDate = moment()
                                        .startOf("day")
                                        .format("YYYY-MM-DD HH:mm");
                                    let eDate = moment()
                                        .endOf("day")
                                        .format("YYYY-MM-DD HH:mm");

                                    this.setState({ disabledRangePicker: true });
                                    this.setState({ showDate: false }, () => {
                                        this.chooseRangerPicker([sDate, eDate]);
                                        setTimeout(() => {
                                            this.onOk();
                                        }, 500);
                                    });
                                }}
                            >
                                Today's FollowUp ({followUpCounts.todaysTotals})
                            </Button>
                            <Button
                                className={styles.btn1}
                                type="primary"
                                onClick={() => {
                                    let sDate = moment()
                                        .subtract(7, "days")
                                        .startOf("day")
                                        .format("YYYY-MM-DD HH:mm");
                                    let eDate = moment()
                                        .endOf("day")
                                        .format("YYYY-MM-DD HH:mm");

                                    this.setState({ disabledRangePicker: true });
                                    this.setState({ showDate: false }, () => {
                                        this.chooseRangerPicker([sDate, eDate]);
                                        setTimeout(() => {
                                            this.onOk();
                                        }, 500);
                                    });
                                }}
                            >
                                Last Week ({followUpCounts.lastSevenDaysTotals})
                            </Button>
                            <Button
                                className={styles.btn1}
                                type="primary"
                                onClick={() => {
                                    let sDate = moment()
                                        .startOf("day")
                                        .subtract(15, "days")
                                        .format("YYYY-MM-DD HH:mm");
                                    let eDate = moment()
                                        .endOf("day")
                                        .format("YYYY-MM-DD HH:mm");

                                    this.setState({ disabledRangePicker: true });
                                    this.setState({ showDate: false }, () => {
                                        this.chooseRangerPicker([sDate, eDate]);
                                        setTimeout(() => {
                                            this.onOk();
                                        }, 500);
                                    });
                                }}
                            >
                                Last 15 Days ({followUpCounts.lastFiftenDaysTotals})
                            </Button>
                            <Button
                                className={styles.btn1}
                                type="primary"
                                onClick={() => {
                                    let sDate = moment()
                                        .subtract(30, "days")
                                        .startOf("day")
                                        .format("YYYY-MM-DD HH:mm");
                                    let eDate = moment()
                                        .endOf("day")
                                        .format("YYYY-MM-DD HH:mm");

                                    this.setState({ disabledRangePicker: true });
                                    this.setState({ showDate: false }, () => {
                                        this.chooseRangerPicker([sDate, eDate]);
                                        setTimeout(() => {
                                            this.onOk();
                                        }, 500);
                                    });
                                }}
                            >
                                Last Month ({followUpCounts.lastTharteenDaysTotals})
                            </Button>
                            <Button
                                className={styles.btn1}
                                type="primary"
                                onClick={() => {
                                    this.setState({ disabledRangePicker: false });
                                }}
                            >
                                Custom Date Range
                            </Button>
                        </Col>
                        <Col span={17}>
                            <h4>FILTER BY DATE(Next Follow Up)</h4>
                            <RangePicker
                                disabled={this.state.disabledRangePicker}
                                key={this.state.showDate ? "78" : "326"}
                                showTime={{ format: "HH:mm" }}
                                defaultValue={
                                    this.state.showDate
                                        ? [moment(this.state.time.from), moment(this.state.time.to)]
                                        : []
                                }
                                format="YYYY-MM-DD HH:mm"
                                placeholder={["Start Time", "End Time"]}
                                onChange={this.chooseRangerPicker}
                                onOk={this.onOk}
                            />
                        </Col>

                    </Row>
                </Card>

                {this.state.showResults ? (
                    <Card bordered={true}>
                        <TableComp
                            columns={columns}
                            ref={this.table}
                            apiRequest={this.apiRequest}
                            pagination={{
                                showSizeChanger: true,
                                defaultPageSize: "50",
                                pageSizeOptions: ["10", "20", "50", "100", "1000"],
                            }}
                        />
                    </Card>
                ) : null}
            </PageHeaderWrapper>
        );
    }
}

const mapStateToProps = ({ global, router }) => ({
    categories: global.categories,
    search: router.location.search,
    currentUser: global.currentUser,
});
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UniversityAgreementFollowUps);
